import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {ThemePalette} from '@angular/material/core';
import {ProgressBarMode} from '@angular/material/progress-bar'
import { environment } from 'src/environments/environment';
import { SocketServiceService } from 'src/app/socket-Service/socket-service.service';
import { WhatsappEmbeddedServiceService } from 'src/app/whatsapp-embedded-signup/whatsapp-embedded-service.service';
import { emailValidator, urlValidator } from 'src/app/emailHelper';
import { Subscription } from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
declare var FB: any;
declare const window: any;
@Component({
  selector: 'app-whatsapp-embedded-signup',
  templateUrl: './whatsapp-embedded-signup.component.html',
  styleUrls: ['./whatsapp-embedded-signup.component.scss']
})
export class WhatsappEmbeddedSignupComponent implements OnInit {
  success:boolean = false;
  authorised = true;
  loadershow:boolean= false;
  subscription: Subscription = new Subscription;
  color: ThemePalette = "primary";
  mode: ProgressBarMode = "buffer";
  value = 50;
  bufferValue = 75;
  screenWidth: number = 100;
  webhookUrl: string = "";
  webhookErr: boolean = false;
  validWebhookUrl: boolean = false;
  headerValue: string = '';
  headerKey: string = '';
  headerKey1: string = '';
  headerKey2: string = '';
  headerValue1: string = '';
  headerValue2: string = '';
  validateSpinner:boolean = false;
  showFbLoginLoader:boolean = false;
  showFbLoginLoaderSuccess:boolean = false;
  showSetWebhook:boolean = true;
  // checkWABALimitStatus:boolean = false;
  watsappForm: FormGroup;
  imgEmbeddedURL: any = null;
  exhibitEmbeddedUrl: any = null;
  scheduleEmbeddedURL: any = null;
  embeddedSubmitted: boolean = false;
  // responseScheduleEmbeddedURL:any;
  // responseExhibitembeddedURL:any;
  whatsappembeddedForm: FormGroup;
  imageSize: number = 0;
  imageWhatsapp: any;
  responseImgEmbeddedURL:any;
  ImgEmbedded:boolean= false;
  regId:any;
  subscriberId:any;
  state:any;
  imageLoader: boolean = false;
  exhibitLoader: boolean = false;
  scheduleLoader: boolean = false;
  wabaLocalStorage: any = {
    country : 'Default'
  };
  wabaLocalStorageList: any;
  constructor(private toastr: ToastrService,
    private formBuilder: FormBuilder, 
    private Socket: SocketServiceService,
    public translate: TranslateService,
    public WhatsappEmbeddedService: WhatsappEmbeddedServiceService,
    private router: Router,
    private route: ActivatedRoute
  ) { 
    this.subscriberId = localStorage.getItem('subscriberId');
    this.whatsappembeddedForm = this.formBuilder.group({
      embeddedManagerId: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      embeddedLogo: [File, [Validators.required]],
      embeddedAddress: ['', [Validators.required, Validators.maxLength(256)]],
      embeddedEmail: ['',[Validators.required, Validators.maxLength(128), emailValidator]],
      embeddedUrl: ['', [Validators.required, Validators.maxLength(256), urlValidator]],
      embeddedProcessedBy:['customer_server', Validators.required],
      // embeddedExihibitB: [File, [Validators.required]],
      // embeddedSchedule1 : [File, [Validators.required]],
      embeddedStatus: ['', [Validators.required, Validators.maxLength(139)]],
      webhookurl: [''],
      headerKey: [''],
      headerValue: [''],
      headerKey1: [''],
      headerValue1: [''],
      headerKey2: [''],
      headerValue2: [''],
    });
    if (this.router.getCurrentNavigation()?.extras?.state ?. id) {
      this.state = this.router.getCurrentNavigation().extras.state.id;
      console.log('state', this.state);
    }
  }

  ngOnInit(): void {
    // this.Socket.connect();
    window.scrollTo(0, 0)
    this.regId = this.getUrlParameter('id');
    // this.subscription = this.Socket.getMessage().subscribe((message) => {
    //   if(message){
    //     this.showFbLoginLoader = false;
    //     if(message.status==200){
    //       this.router.navigate(['/thankyou'], { state: { success: true } });
    //       this.whatsappembeddedForm.reset();
    //       this.responseExhibitembeddedURL = "";
    //       this.responseScheduleEmbeddedURL='';
    //       this.responseImgEmbeddedURL="";
    //       this.showFbLoginLoaderSuccess = true;
    //      }
    //     }
    // });
    this.screenWidth = window.innerWidth;

    window.fbAsyncInit = function () {
      // JavaScript SDK configuration and setup
      FB.init({
        // appId: environment.clientID, // Facebook App ID
        appId: 221460181203789, // Facebook App ID
        cookie: true, // enable cookies
        xfbml: true, // parse social plugins on this page
        version: 'v24.0', //Graph API version
      });
    };

    // Load the JavaScript SDK asynchronously
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
    this.getWabaLocalStorage();
  }
  getUrlParameter(name:any) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
    const results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
  
   fetchSharedWhatsAppAccountIds(accessToken:any) {
    FB.api(
      '/debug_token?input_token=' +
        accessToken +
        '&access_token=your-system-user-access-token',
      function (response:any) {
        if (
          response &&
          response.data &&
          response.data.granular_scopes &&
          !response.error
        ) {
          const waScope = response.data.granular_scopes.find(
            ({ scope }) => scope === 'whatsapp_business_management'
          );
          if (waScope != null && waScope.target_ids != null) {
            // Proceed with WhatsApp Business API
            // integration using waScope.target_ids
          }
        }
      }
    );
  }
   fblogin() {
    this.imageWhatsapp = this.imageSize * 1024 * 1024;
    if (this.imageWhatsapp > 5000000) {
      return;
    }
  
    let headerDetails = '';
    if(this.headerKey !== '' && this.headerValue !== ''){
      headerDetails= '"'+this.headerKey+'":"'+ this.headerValue+ '"';
    }
    if(this.headerKey1 !== '' && this.headerValue1 !== ''){
      headerDetails+= ',"' + this.headerKey1+'":"'+ this.headerValue1+ '"';
    }
  
    if(this.headerKey2 !== '' && this.headerValue2 !== ''){
      headerDetails+= ',"' + this.headerKey2+'":"'+ this.headerValue2+ '"';
    }
  
    if(headerDetails){
      headerDetails = JSON.parse('{'+ headerDetails + '}');
    }
  
    FB.login(
      (response:any) => {
        response.connectorId = this.state.connectorId ? this.state.connectorId:'';
        response.apiType = this.state.apiType ? this.state.apiType : '';
        response.appId = this.state.appId ? this.state.appId : '';
        // response.subscriberId = this.regId ? this.regId : this.subscriberId;
        response.website = this.webhookUrl ? this.webhookUrl :'';
        response.headerDetails = headerDetails ? headerDetails : {};
        this.showFbLoginLoader = true;
        response.embeddedManagerId = this.whatsappembeddedForm.value ? this.whatsappembeddedForm.value.embeddedManagerId :'',
        response.embeddedLogo = this.responseImgEmbeddedURL ? this.responseImgEmbeddedURL :'',
        response.embeddedStatus = this.whatsappembeddedForm.value ? this.whatsappembeddedForm.value.embeddedStatus : '',
        response.embeddedAddress = this.whatsappembeddedForm.value ? this.whatsappembeddedForm.value. embeddedAddress : '',
        response.embeddedEmail = this.whatsappembeddedForm.value ? this.whatsappembeddedForm.value.embeddedEmail :'',
        response.embeddedUrl = this.whatsappembeddedForm.value ? this.whatsappembeddedForm.value.embeddedUrl :'',
        response.embeddedProcessedBy = this.whatsappembeddedForm.value ? this.whatsappembeddedForm.value.embeddedProcessedBy :'',
        // response.embeddedExihibitB = this.responseExhibitembeddedURL ? this.responseExhibitembeddedURL :'',
        // response.embeddedSchedule1 = this.responseScheduleEmbeddedURL ? this.responseScheduleEmbeddedURL :'',
        response.waba_local_storage = this.wabaLocalStorage && this.wabaLocalStorage.code ? this.wabaLocalStorage.code : '';
        console.log("response", response)
        if(response.status == "unknown"){
          this.toastr.error('Error while Response sent', 'Error', { timeOut: 8000, closeButton:true });
          this.showFbLoginLoader = false;
          }
        else{
          this.WhatsappEmbeddedService.whatsappembedded(response).subscribe(
            (data) => {
              if (data.status === true) {
                this.showFbLoginLoader = false;
                if(data.info && data.info.connectorId){
                  this.toastr.success( '', 'Success', { timeOut: 8000, closeButton:true});      
                } 
                else {
                  this.toastr.success( data.info, '', { timeOut: 8000, closeButton:true}); 
                }
              } else {
                this.showFbLoginLoader = false;
                this.toastr.error( data.info, '', { timeOut: 8000, closeButton:true}); 
              }
              this.router.navigate(['/application'], { state: { id: this.state.appId } });
            },
            (error) => {
              this.toastr.error('Error while Response sent', 'Error', { timeOut: 8000, closeButton:true });
              this.router.navigate(['/application'], { state: { id: this.state.appId } });
              this.showFbLoginLoader = false;
            }
          );     
         }
        if (response.authResponse) {
          const accessToken = response.authResponse.code;
          this.fetchSharedWhatsAppAccountIds(accessToken);
        } else {
          console.log('User cancelled login or did not fully authorize.');
        }
      },
      {
        config_id: '291027070505536', // configuration ID goes here
        response_type: 'code',    // must be set to 'code' for System User access token
        override_default_response_type: true,
        extras: {
          feature: 'whatsapp_embedded_signup',
          setup: {
            // Prefilled data can go here
          },
        },
      }, (err)=>{
        console.log(err)
      }
    );
    
  }
  
   webhookUrlChange() {
    this.webhookErr = false;
    this.validWebhookUrl = false;
  }
  webhookValidate(){
    this.loadershow=true;
    // let website = this.webhookUrl;
    let website= this.whatsappembeddedForm.value.webhookurl;
    this.webhookUrl = this.whatsappembeddedForm.value.webhookurl;
    if(!website){
      this.toastr.error('Invalid Webhook URL', 'Error', { timeOut: 8000, closeButton:true });  }
    let headerDetails = '';
      this.headerKey = this.whatsappembeddedForm.value.headerKey
      this.headerValue = this.whatsappembeddedForm.value.headerValue
    if(this.headerKey !== '' && this.headerKey !== null && this.headerValue !== '' && this.headerValue !== null){
      headerDetails= '"'+this.headerKey+'":"'+ this.headerValue+ '"';
    }
    this.headerKey1 = this.whatsappembeddedForm.value.headerKey1
    this.headerValue1 = this.whatsappembeddedForm.value.headerValue1
    if(this.headerKey1 !== '' && this.headerKey1 !== null && this.headerValue1 !== '' && this.headerValue1 !== null){
        headerDetails+= ',"' + this.headerKey1+'":"'+ this.headerValue1+ '"';
    }
     this.headerKey2 = this.whatsappembeddedForm.value.headerKey2
     this.headerValue2 = this.whatsappembeddedForm.value.headerValue2
    if(this.headerKey2 !== '' && this.headerKey2 !== null && this.headerValue2 !== '' && this.headerValue2 !== null){
      headerDetails+= ',"' + this.headerKey2+'":"'+ this.headerValue2+ '"';
    }
    if(headerDetails){
      headerDetails = JSON.parse('{'+ headerDetails + '}');
    }
    let validateArgs = {
      'website' : website,
      'headerDetails': headerDetails ? headerDetails : {},
    }
    this.validateSpinner =true;
    this.showFbLoginLoaderSuccess =false;
    this.WhatsappEmbeddedService.validateWeb(validateArgs).subscribe((data)=>{
      if (data.data.status == 200 &&
        data.data.info.toLowerCase() === 'ok') {
          this.loadershow=false;
          this.toastr.success('Webhook URL validated successfully', 'Success', { timeOut: 8000, closeButton:true});      
          this.webhookErr = false;
        this.validWebhookUrl = true;
      }
      else{
        this.loadershow=false;
        this.toastr.error('Error validating webhook URL', 'Error', { timeOut: 8000, closeButton:true });   
        this.webhookErr = true;
        this.validWebhookUrl = false;
      }
      this.validateSpinner =false;
    }, err =>{
      this.loadershow=false;
      this.toastr.error('Error validating webhook URL', 'Error', { timeOut: 8000, closeButton:true });
      this.webhookErr = true;
      this.validWebhookUrl = false;
      this.validateSpinner =false;
    })
  }
  onFileEmbeddedChanged( event, type){
      if (type == 'watsappEmbeddedlogo') {
        this.imageLoader = true;
          if (event.target.files.length > 0) {
          this.whatsappembeddedForm.controls["embeddedLogo"].setValue(event.target.files);
          var reader = new FileReader();
          this.imageSize = event.target.files[0].size / 1024 / 1024;
          reader.readAsBinaryString(this.whatsappembeddedForm.controls.embeddedLogo.value[0]);
          reader.onload = (e: any) => {
            this.imgEmbeddedURL = e.target.result;
            let args = {
              data: btoa(this.imgEmbeddedURL.toString()),
              contentType:this.whatsappembeddedForm.controls.embeddedLogo.value[0].type,
            };
            this.WhatsappEmbeddedService.fileupload(args).subscribe(
              (response) => {
                if (response.status == 200) {
                  this.imageLoader = false;
                 this.responseImgEmbeddedURL = response.data;
                }
                else{
                  this.imageLoader = false;
                  this.toastr.error('Error uploading image. Please try again.', 'Error', { timeOut: 8000, closeButton:true });
                }
              },
              (error) => {
                // this.onCancel();
                this.loadershow=false;
                this.imageLoader = false;
                // this.isLoading = false;
                this.toastr.error('Error uploading image. Please try again.', 'Error', { timeOut: 8000, closeButton:true });
            });
          };
          // this.imgEmbeddedURL = reader.readAsDataURL(event.target.files[0]);
        } else {
          this.imageLoader = false;
           this.imgEmbeddedURL = '';
          this.imageSize = 0;
          this.whatsappembeddedForm.controls["embeddedLogo"].setValue('');
        }
      } 
      // else if (type == 'watsappEmbeddedexhibit') {
      //   this.exhibitLoader = true;
      //   if (event.target.files.length > 0) {
      //     this.whatsappembeddedForm.controls["embeddedExihibitB"].setValue(event.target.files);
      //     var reader = new FileReader();
      //     reader.readAsBinaryString(this.whatsappembeddedForm.controls["embeddedExihibitB"].value[0]);
      //     reader.onload = (e) => {
      //       this.exhibitEmbeddedUrl = e.target.result;
      //       let args = {
      //         data: btoa(this.exhibitEmbeddedUrl.toString()),
      //         contentType: this.whatsappembeddedForm.controls["embeddedExihibitB"].value[0].type,
      //       };
      //       this.WhatsappEmbeddedService.fileupload(args).subscribe(
      //         (response) => {
      //           if (response.status == 200) {
      //             this.exhibitLoader = true;
      //            this.responseExhibitembeddedURL = response.data;
      //           }
      //           else{
      //             this.exhibitLoader = true;
      //             this.toastr.error('Error uploading image. Please try again.', 'Error', { timeOut: 8000, closeButton:true });
      //           }
      //         },
      //         (error) => {
      //           this.exhibitLoader = true;
      //           this.toastr.error('Error uploading image. Please try again.', 'Error', { timeOut: 8000, closeButton:true });
      //       });
      //     };
      //   } else {
      //     this.exhibitEmbeddedUrl = '';
      //     this.watsappForm.controls["embeddedExihibitB"].setValue('');
      //     // this.responseExhibitURL = '';
      //   }
  
      // } else if (type == 'watsappEmbeddedschedule') {
      //   this.scheduleLoader = true;
      //   if (event.target.files.length > 0) {
      //     this.whatsappembeddedForm.controls["embeddedSchedule1"].setValue(
      //       event.target.files
      //     );
      //     var reader = new FileReader();
      //     reader.readAsBinaryString(this.whatsappembeddedForm.controls["embeddedSchedule1"].value[0]);
      //     reader.onload = (e) => {
      //       this.scheduleEmbeddedURL = e.target.result;
      //       let args = {
      //         data: btoa(this.scheduleEmbeddedURL.toString()),
      //         contentType: this.whatsappembeddedForm.controls["embeddedSchedule1"].value[0].type,
      //       };
      //       this.WhatsappEmbeddedService.fileupload(args).subscribe(
      //         (response) => {
      //           if (response.status == 200) {
      //             this.scheduleLoader = false;
      //             this.responseScheduleEmbeddedURL = response.data;
      //           }
      //           else{
      //             this.scheduleLoader = false;
      //             this.toastr.error('Error uploading image. Please try again.', 'Error', { timeOut: 8000, closeButton:true });
      //           }
      //         },
      //         (error) => {
      //           this.scheduleLoader = false;
      //           this.toastr.error('Error uploading image. Please try again.', 'Error', { timeOut: 8000, closeButton:true });
      //         }
      //       );
      //     };
      //   } else {
      //     this.scheduleLoader = false;
      //     this.scheduleEmbeddedURL = '';
      //     this.whatsappembeddedForm.controls["embeddedSchedule1"].setValue('');
      //   }
      // } 
      else {
      }
    if(this.responseImgEmbeddedURL ){
      this.ImgEmbedded = true;
    }
  }
  onCancel() {
    this.whatsappembeddedForm.reset();
    // this.watsappForm.controls.isVerified.setValue('yes');
    // this.watsappForm.controls.isMobile.setValue('mobile');
    // this.watsappForm.controls.processedBy.setValue('customer_server');
    this.imageSize = 0;
    this.imgEmbeddedURL = null;
    this.exhibitEmbeddedUrl = null;
    this.scheduleEmbeddedURL = null;
    this.validWebhookUrl = false;
    this.showSetWebhook = true;
    this.showFbLoginLoaderSuccess = false;
  }
  get e() {
    return this.whatsappembeddedForm.controls;
  }
  incommingEmbeddedMessageProcessed(event){
    if(event == 'customer_server'){
      this.showSetWebhook = true;
    }
    else{
      this.showSetWebhook = false;
    }
  }
  getWabaLocalStorage() {
    this.WhatsappEmbeddedService.getWabaLocalStorages().subscribe((response) => {
        this.wabaLocalStorageList = response.data || [];
        this.wabaLocalStorageList.push({
          country: 'Default'
        }, (err) => {
          console.log("err", err)
        })
    })
  }
  changeSelectedStorage(value) {
    this.wabaLocalStorage = value;
  }

}
